import { TeamMember } from '@this+that/models';

export function getTeamMemberDisplayName(member: TeamMember): string {
  return member.name ?? member.email ?? '';
}
